import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  data: [],
  loading: false,
  error: null,
};

// Actions
const FETCH_REQUEST = 'areas/FETCH_REQUEST';
const FETCH_CANCEL = 'areas/FETCH_CANCEL';
const FETCH_DONE = 'areas/FETCH_DONE';

// Reducers
export default createReducer(INIT_STATE, {
  [FETCH_REQUEST](state) {
    return {
      ...state,
      loading: true,
    };
  },
  [FETCH_CANCEL](state, payload) {
    return {
      ...state,
      loading: false,
      error: payload,
    };
  },
  [FETCH_DONE](state, payload) {
    return {
      ...state,
      loading: false,
      data: [...state.data, ...payload],
    };
  },
});

// Action creators
export const request = () => ({
  type: FETCH_REQUEST,
});

export const cancel = (error) => ({
  type: FETCH_CANCEL,
  payload: error,
});

export const done = (areas) => ({
  type: FETCH_DONE,
  payload: areas,
});
